<template>
    <div class="row">
        <div class="col-lg-12 col-md-12">

            <div class="card headertop">
                <div class="card-header">
                    <h4 class="title" style="text-align:center;margin:auto; padding-bottom:15px;">Contract details</h4>
                    <button v-if="contract.pdf" type="submit" class="btn btn-info btn-fill" style="float:right;margin-top: -50px;" @click.prevent="downloadPdf">
                        Download PDF
                    </button>
                    <hr>
                    <div class="card-body" style="margin:auto;" v-if="role === 'agent' || role === 'supplier'">
                        <!--
                        <form>


                            <div class="row" style="margin:auto;">
                                <div class="col-md-2">
                                    <fg-input label="Change the status" v-if="role === 'agent'">
                                        <el-select class="select-primary"
                                                   size="large"
                                                   placeholder="Single Select"
                                                   v-model="update.status">
                                            <el-option v-for="option in categoryAgents"
                                                       class="select-primary"
                                                       :value="option.value"
                                                       :label="option.label"
                                                       :key="option.label">
                                            </el-option>
                                        </el-select>
                                    </fg-input>
                                    <fg-input label="Change the status" v-if="role === 'supplier'">
                                        <el-select class="select-primary"
                                                   size="large"
                                                   placeholder="Single Select"
                                                   v-model="update.status">
                                            <el-option v-for="option in categorySuppliers"
                                                       class="select-primary"
                                                       :value="option.value"
                                                       :label="option.label"
                                                       :key="option.label">
                                            </el-option>
                                        </el-select>
                                    </fg-input>
                                </div>
                                <div class="col-md-2">

                                    <fg-input type="text"
                                              label="UID"
                                              v-model="update.uid">
                                    </fg-input>
                                </div>
                                <div class="col-md-6">
                                    <fg-input type="text"
                                              label="Reason"
                                              v-model="update.note">
                                    </fg-input>
                                </div>
                                <div class="col-md-2" style="margin:auto">
                                    <button type="submit" class="btn btn-success btn-fill" style="margin-top: 25px;" @click.prevent="updateContract">
                                        Update
                                    </button>
                                </div>

                            </div>
                        </form>
-->
                        <div v-if="role === 'agent' && (contract.state === 'pending kb' || contract.state === 'attente terminal')" class="col-md-12" style="text-align:center; margin:auto">
                            <button type="submit" class="btn btn-success btn-fill" style="margin:50px; width:25%;height:50px;" @click.prevent="updateContractbtn('valide')">
                                Submit for supplier validation
                            </button>
                            <button type="submit" v-if="contract.state != 'attente terminal'" class="btn btn-info btn-fill" style="margin:50px; width:25%; height:50px;" @click.prevent="updateContractbtn('attente terminal')">
                                Wait for terminals
                            </button>
                            <button type="submit" class="btn btn-danger btn-fill" style="margin: 50px; width:25%; height:50px;" @click.prevent="updateContractbtn('refus')">
                                Refuse contract
                            </button>
                        </div>

                        <div v-if="role === 'agent' && (contract.state === 'refus' || contract.state === 'refus fournisseur')" class="col-md-12" style="text-align:center; margin:auto">
                            <button type="submit" class="btn btn-info btn-fill" style="margin:50px; width:25%;height:50px;" @click.prevent="updateContractbtn('pending kb')">
                                Revert as pending contract
                            </button>
                        </div>

                        <div v-if="(role === 'supplier') && (contract.state === 'valide')" class="col-md-12" style="text-align:center; margin:auto">
                            <button type="submit" class="btn btn-success btn-fill" style="margin:50px; width:25%;height:50px;" @click.prevent="updateContractbtn('validation fournisseur')">
                                Validate contract
                            </button>
                            <button type="submit" class="btn btn-danger btn-fill" style="margin: 50px; width:25%; height:50px;" @click.prevent="updateContractbtn('refus fournisseur')">
                                Refuse contract
                            </button>
                        </div>


                    </div>
                </div>

                <div class="contract-card">
                    <div class="card-header">
                        <h4 class="title">History</h4>
                    </div>
                    <div class="card-body">
                        <form>

                            <div class="row">
                                <el-table
                                        :data="contract.history"
                                        height="250"
                                        style="width: 100%">
                                    <el-table-column
                                            prop="date"
                                            label="Date"
                                            width="180">
                                        <template slot-scope="scope">
                                            <span style="margin-left: 10px">{{ scope.row.date | formatDate }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="login"
                                            label="Supplier"
                                            width="250">
                                    </el-table-column>
                                    <el-table-column
                                            prop="action"
                                            label="Action"
                                            width="230">
                                    </el-table-column>
                                    <el-table-column
                                            prop="reason"
                                            label="Reason">
                                    </el-table-column>
                                </el-table>
                            </div>


                            <div class="clearfix"></div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="card company-card">

                <!--
                <iframe :src="link.href " width="100%" height="500px">
                </iframe>
                -->

                <div class="card-header">
                    <h4 class="title">Company</h4>
                </div>
                <div class="card-body">
                    <form>
                        <div class="row">
                            <div class="col-md-5">
                                <fg-input type="text"
                                          label="Company"
                                          :disabled="true"
                                          v-model="contract.company_name">
                                </fg-input>
                            </div>
                            <div class="col-md-3">

                                <fg-input type="text"
                                          label="VAT"
                                          :disabled="true"
                                          v-model="contract.vat">
                                </fg-input>
                            </div>
                            <div class="col-md-4">
                                <fg-input type="text"
                                          label="Legal form"
                                          :disabled="true"
                                          v-model="contract.legal_form">
                                </fg-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <fg-input type="text"
                                          label="First Name"
                                          :disabled="true"
                                          v-model="contract.contact.first_name">
                                </fg-input>
                            </div>
                            <div class="col-md-6">
                                <fg-input type="text"
                                          label="Last Name"
                                          :disabled="true"
                                          v-model="contract.contact.last_name">
                                </fg-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <fg-input type="text"
                                          label="Street"
                                          :disabled="true"
                                          v-model="contract.companyAddress.street">
                                </fg-input>
                            </div>

                            <div class="col-md-2">
                                <fg-input type="text"
                                          label="Street number"
                                          :disabled="true"
                                          v-model="contract.companyAddress.street_number">
                                </fg-input>
                            </div>

                            <div class="col-md-2">
                                <fg-input type="text"
                                          label="Postal code"
                                          :disabled="true"
                                          v-model="contract.companyAddress.postal_code">
                                </fg-input>
                            </div>

                            <div class="col-md-2">
                                <fg-input type="text"
                                          label="Locality"
                                          :disabled="true"
                                          v-model="contract.companyAddress.locality">
                                </fg-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <fg-input type="text"
                                          label="Email"
                                          :disabled="true"
                                          v-model="contract.contact.email">
                                </fg-input>
                            </div>
                            <div class="col-md-4">
                                <fg-input type="text"
                                          label="Phone"
                                          :disabled="true"
                                          v-model="contract.contact.phone_number">
                                </fg-input>
                            </div>
                            <div class="col-md-4">
                                <fg-input type="text"
                                          label="Language"
                                          :disabled="true"
                                          v-model="contract.language">
                                </fg-input>
                            </div>
                        </div>

                        <div class="clearfix"></div>
                    </form>
                </div>




                <div class="pos-card">
                    <div class="card-header">
                        <h4 class="title">Installation</h4>
                    </div>
                    <div class="card-body">
                        <form>

                            <div class="row">
                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="POS name"
                                              :disabled="true"
                                              v-model="contract.installationAddress.name">
                                    </fg-input>
                                </div>
                                <div class="col-md-4">
                                    <fg-input type="text"
                                              label="Street"
                                              :disabled="true"
                                              v-model="contract.installationAddress.street">
                                    </fg-input>
                                </div>

                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="Street number"
                                              :disabled="true"
                                              v-model="contract.installationAddress.street_number">
                                    </fg-input>
                                </div>

                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="Postal code"
                                              :disabled="true"
                                              v-model="contract.installationAddress.postal_code">
                                    </fg-input>
                                </div>

                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="Locality"
                                              :disabled="true"
                                              v-model="contract.installationAddress.locality">
                                    </fg-input>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-md-5">
                                    <fg-input type="text"
                                              label="Activity"
                                              :disabled="true"
                                              v-model="contract.activity">
                                    </fg-input>
                                </div>
                                <div class="col-md-1">
                                    <fg-input type="text"
                                              label="Monday"
                                              :disabled="true"
                                              v-model="contract.calendar.monday">
                                    </fg-input>
                                </div>
                                <div class="col-md-1">
                                    <fg-input type="text"
                                              label="Tuesday"
                                              :disabled="true"
                                              v-model="contract.calendar.tuesday">
                                    </fg-input>
                                </div>
                                <div class="col-md-1">
                                    <fg-input type="text"
                                              label="Wednesday"
                                              :disabled="true"
                                              v-model="contract.calendar.wednesday">
                                    </fg-input>
                                </div>
                                <div class="col-md-1">
                                    <fg-input type="text"
                                              label="Thursday"
                                              :disabled="true"
                                              v-model="contract.calendar.thursday">
                                    </fg-input>
                                </div>
                                <div class="col-md-1">
                                    <fg-input type="text"
                                              label="Friday"
                                              :disabled="true"
                                              v-model="contract.calendar.friday">
                                    </fg-input>
                                </div>
                                <div class="col-md-1">
                                    <fg-input type="text"
                                              label="Saturday"
                                              :disabled="true"
                                              v-model="contract.calendar.saturday">
                                    </fg-input>
                                </div>
                                <div class="col-md-1">
                                    <fg-input type="text"
                                              label="Sunday"
                                              :disabled="true"
                                              v-model="contract.calendar.sunday">
                                    </fg-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <fg-input type="text"
                                              label="Bank"
                                              :disabled="true"
                                              v-model="contract.payment.bank">
                                    </fg-input>
                                </div>
                                <div class="col-md-3">
                                    <fg-input type="text"
                                              label="IBAN"
                                              :disabled="true"
                                              v-model="contract.payment.iban">
                                    </fg-input>
                                </div>
                                <div class="col-md-3">
                                    <fg-input type="text"
                                              label="BIC"
                                              :disabled="true"
                                              v-model="contract.payment.bic">
                                    </fg-input>
                                </div>
                                <div class="col-md-3">
                                    <fg-input type="text"
                                              label="Beneficiary"
                                              :disabled="true"
                                              v-model="contract.payment.beneficiary">
                                    </fg-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="Product"
                                              :disabled="true"
                                              v-model="contract.product">
                                    </fg-input>
                                </div>
                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="UID"
                                              :disabled="true"
                                              v-model="contract.uid">
                                    </fg-input>
                                </div>
                                <div class="col-md-4">

                                    <fg-input type="text"
                                              label="State"
                                              :disabled="true"
                                              v-model="contract.state">
                                    </fg-input>
                                </div>
                                <div class="col-md-4">
                                    <fg-input type="text"
                                              label="Commercial"
                                              :disabled="true"
                                              v-model="contract.user">
                                    </fg-input>
                                </div>
                            </div>
                        </form>
                        <div class="card-header">
                            <h4 class="title">Terminals</h4>
                        </div>

                        <div class="row" v-for="el, index in contract.terminals">
                            <div class="col-md-3">
                                <fg-input type="text"
                                          label="Terminal supplier"
                                          :disabled="true"
                                          v-model="el.supplier">
                                </fg-input>
                            </div>
                            <div class="col-md-3">
                                <fg-input type="text"
                                          label="Terminal type"
                                          :disabled="true"
                                          v-model="el.type">
                                </fg-input>
                            </div>
                            <div class="col-md-4">
                                <fg-input type="text"
                                          label="TID"
                                          :disabled="true"
                                          v-model="el.tid">
                                </fg-input>
                            </div>
                        </div>

                        <div class="clearfix"></div>

                        </div>
                    </div>
                </div>


            </div>



        </div>

    </div>
</template>
<script>
    import Vue from 'vue'
    import {Table, TableColumn, Select, Option} from 'element-ui'
    import VueSweetalert2 from 'vue-sweetalert2'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(VueSweetalert2);
    export default {

        components: {

        },
        data () {
            return {
                contractPage: true,
                contract: {},
                role: localStorage.role,
                terminals: [],
                urlPdf: '',
                url: '',
                link: {
                    href: ''
                },
                type: '',
                supplier:'',
                tid:'',
                update : {
                    status: '',
                    uid: '',
                    note: '',
                    id: '',
                },
                categoryAgents: [{ value: 'refus', label:'Refus'},{ value: 'attente terminal', label:'Attente Terminal'}, { value: 'valide', label:'Valide'}],
                categorySuppliers: [{ value: 'validation fournisseur', label:'Validation Fournisseur'},  { value: 'refus Fournisseur', label:'refus Fournisseur'}] // { value: 'correction fournisseur', label:'Correction Fournisseur'},
            }
        },
        mounted() {
            this.getContract(),
                this.getTerminals()
        },
        methods: {
          getTerminals() {
            this.$http({
              method: 'get',
              url: this.$apiUrl + '/terminal/terminalBySupplier',
              headers: {'Authorization': 'Bearer ' + localStorage.token}
            }).then(response => (
                console.log(response.data),
                    this.terminals = response.data
            )).catch(err => {
              this.$notify({
                message: 'Impossible to retrieve data',
                type: 'danger',
                horizontalAlign: 'center',
                verticalAlign: 'top'
              })
            })
          },
            downloadPdf () {
                this.$http({
                    method: 'get',
                    url: this.$apiUrl + '/contract/pdf',
                    headers: {'Authorization': 'Bearer ' + localStorage.token},
                    responseType: 'blob',
                    params: {pdf: this.contract.pdf}
                }).then(response => (
                    this.link = document.createElement('a'),
                        this.url = window.URL.createObjectURL(new Blob([response.data])),
                        this.link.href = this.url, this.link.setAttribute('download', this.contract.pdf), document.body.appendChild(this.link), this.link.click()
                )).catch(err => {
                    alert(err)
                })
            },
            getContract() {
                this.$http({
                    method: 'get',
                    url: this.$apiUrl + '/contract/contracts',
                    headers: {'Authorization': 'Bearer ' + localStorage.token},
                    params: {by: 'id',id: this.$route.query.id.toString()},
                }).then(response => {
                    this.contract = response.data,
                        this.update.status = response.data.state,
                        this.update.uid = response.data.uid,
                        this.update.id = response.data._id,
                        this.urlPdf = "https://e-contracts.eu/contract/pdf?pdf=" + this.contract.pdf
                        if(!this.contract.calendar) {
                          this.contract.calendar = {
                            monday: '',
                            tuesday: '',
                            wednesday: '',
                            thursday: '',
                            friday: '',
                            saturday: '',
                            sunday: ''
                          }
                        }
                        if(!this.contract.contact) {
                          this.contract.contact = {
                            first_name: '',
                            last_name: ''
                          }
                        }
                        if(!this.contract.contact.first_name) {
                          this.contract.contact.first_name = ''
                        }
                      if(!this.contract.contact.last_name) {
                        this.contract.contact.last_name = ''
                      }
                      }).catch(err => {
                    this.$notify({
                        message: 'Impossible to retrieve data',
                        type: 'danger',
                        horizontalAlign: 'center',
                        verticalAlign: 'top'
                    })
                })
              if(!this.contract.calendar) {
                this.contract.calendar = {
                  monday: '',
                  tuesday: '',
                  wednesday: '',
                  thursday: '',
                  friday: '',
                  saturday: '',
                  sunday: ''
                }
              }
            },
            updateContractbtn(status) {
                console.log('1')

                if(status=== 'validation fournisseur') {
                    this.$swal.fire({
                        title: "Validate the contract",
                        input: 'text',
                        inputLabel: 'Enter UID below if necessary',
                        inputPlaceholder: '',
                        heightAuto: true,
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Confirm'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.update.status=status
                            console.log(result)
                            if(result.value) {
                                this.update.uid=result.value
                            }
                            this.$http({
                                method: 'put',
                                url: this.$apiUrl + '/contract/contract',
                                headers: {'Authorization': 'Bearer ' + localStorage.token},
                                params: this.update,
                            }).then(response => (
                                this.$notify({
                                    message: 'contract updated',
                                    type: 'success',
                                    horizontalAlign: 'center',
                                    verticalAlign: 'top'
                                }),
                                    this.getContract()
                            )).catch(err => {
                                this.$notify({
                                    message: 'Impossible to update this contract',
                                    type: 'danger',
                                    horizontalAlign: 'center',
                                    verticalAlign: 'top'
                                })
                            })
                            //this.deleteUser(row.username)
                        }
                    })
                } else if (status === 'refus fournisseur') {
                    this.$swal.fire({
                        title: "Refuse the contract",
                        input: 'text',
                        inputLabel: 'Please explain the reason below',
                        inputPlaceholder: '',
                        heightAuto: true,
                        inputValidator: (value) => {
                            if (!value) {
                                return 'Please enter the reason'
                            }
                        },
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Confirm'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.update.status=status
                            console.log(result)
                            if(result.value) {
                                this.update.note=result.value
                            }
                            this.$http({
                                method: 'put',
                                url: this.$apiUrl + '/contract/contract',
                                headers: {'Authorization': 'Bearer ' + localStorage.token},
                                params: this.update,
                            }).then(response => (
                                this.$notify({
                                    message: 'contract updated',
                                    type: 'success',
                                    horizontalAlign: 'center',
                                    verticalAlign: 'top'
                                }),
                                    this.getContract()
                            )).catch(err => {
                                this.$notify({
                                    message: 'Impossible to update this contract',
                                    type: 'danger',
                                    horizontalAlign: 'center',
                                    verticalAlign: 'top'
                                })
                            })
                            //this.deleteUser(row.username)
                        }
                    })
                } else {
                    console.log('here')
                    this.$swal.fire({
                        title: "You will change the status to : " + status,
                        heightAuto: true,
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Confirm',
                        input: 'text',
                        inputLabel: 'Let a note',
                        inputPlaceholder: '',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if(result.value) {
                                this.update.note=result.value
                            }
                            this.update.status=status
                            this.$http({
                                method: 'put',
                                url: this.$apiUrl + '/contract/contract',
                                headers: {'Authorization': 'Bearer ' + localStorage.token},
                                params: this.update,
                            }).then(response => (
                                this.$notify({
                                    message: 'contract updated',
                                    type: 'success',
                                    horizontalAlign: 'center',
                                    verticalAlign: 'top'
                                }),
                                    this.getContract()
                            )).catch(err => {
                                this.$notify({
                                    message: 'Impossible to update this contract',
                                    type: 'danger',
                                    horizontalAlign: 'center',
                                    verticalAlign: 'top'
                                })
                            })
                            //this.deleteUser(row.username)
                        }
                    })
                }







            }
        }
    }

</script>

<style scoped>

</style>
